import PrescriptionComponent from '@/view/prescription'
const Prescription = {
  name: 'prescription',
  component: PrescriptionComponent,
  meta: {
    title: 'prescription'
  }
}
export default Prescription

